import { CapoPlugin } from "/home/dev/uogorod-src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];